import { ReactElement } from "react";
import { EventAttendanceNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type EventAttendanceActivityInvocationProps = {
	data: EventAttendanceNotificationDataViewModel;
	onDismiss: () => void;
};

export const EventAttendanceActivityInvocation = (props: EventAttendanceActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		eventId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.Event}
			id={eventId}
			onClose={onDismiss}
		/>
	);
};

EventAttendanceActivityInvocation.displayName = "EventAttendanceActivityInvocation";